export default __webpack_public_path__ + "static/media/ic_play.0b059921.svg";